import React, { useEffect, useState, useRef, useCallback } from 'react';

import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams, Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';

import MTClientRequirementCircleComponent from './MTClientRequirementCircleComponent';
import MTGallaryModeComponent from './MTGallaryModeComponent';
import MTImageCarouselComponent from './MTImageCarouselComponent';

import Spinner from '../Components/Spinner/Spinner';
import useProcessedShortlist from '../hooks/useProcessedShortlist';
import useQuery from '../hooks/useQuery';
import * as constNames from '../models/constant';
import { Routes as AppRoutes } from '../models/routes';
import * as actionTypes from '../store/actions/index';
import {
  formatDatefromTimeStamp,
  hasVisibleContent,
  hasValidSurveyID,
  validateImageURLString,
} from '../utils/utils';

function MTTourPageComponent(props) {
  const query = useQuery();
  const { surveyId } = useParams();
  const [IsSpinner, SetIsSpinner] = useState(false);

  const data = useSelector((state) => state?.optRed?.data);
  const pdfDownload = useSelector((state) => state?.comRed?.pdfDownload);
  const currentDeal = useSelector((state) => state?.comRed?.currentDeal);
  const shortlist = useSelector((state) => state.shortlistRed.shortlistedOptions);
  const processedShortlist = useProcessedShortlist(shortlist);
  const [shortlistUpdate, setShortlistUpdate] = useState([]);
  const [windowHeight, setWindowHeight] = useState(0);
  const dispatch = useDispatch();
  const isShortlisted = query.get(constNames.IS_SHORTLISTED);
  const [carouselState, setCarouselState] = useState(constNames.FLOOR_PLAN);
  const [selectedPhotoIndex, setPhotoIndex] = useState(0);
  const [galleryMode, setGalleryMode] = useState(false);
  const isPhotoState = carouselState === constNames.PHOTOS;

  const toggleCarouselStateCB = useCallback((cb) => {
    setCarouselState(cb);
  }, []);

  const setPhotoIndexCB = useCallback((cb) => {
    setPhotoIndex(cb);
  }, []);

  const pathParams = useHistory()?.location?.pathname?.split('/');

  const location = useLocation();

  const option = location?.state?.option;

  const surveyData = data;

  useEffect(() => {
    if (
      !pdfDownload &&
      Object.keys(data)?.length === 0 &&
      // && hasValidSurveyID(surveyId)
      surveyId
    ) {
      SetIsSpinner(true);
      dispatch(actionTypes.providerAction(surveyId, isShortlisted, false, false));
    }
  }, [data, dispatch, isShortlisted, pdfDownload, surveyId]);

  useEffect(() => {
    if (Object.keys(currentDeal)?.length > 0) {
      SetIsSpinner(false);
    }
  }, [currentDeal]);

  const imageUrlProcessing = (option) => {
    const imageList = [];

    if (option && option?.images) {
      let customImages = option?.images;

      if (option?.floorPlan) {
        customImages = option?.images?.filter((img) => img !== option?.floorPlan);
      }

      customImages.map((image) => imageList.push(encodeURI(image)));
    }

    const imageFinalList = imageList?.filter((url, index) => {
      return validateImageURLString(url);
    });

    return imageFinalList;
  };

  const setFloorPlanImage = (option) => {
    if (option && option?.floorPlan) {
      return [
        option?.floorPlan.replace(
          process.env.REACT_APP_PDF_IMAGE_URL.trim(),
          process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
        ),
      ];
    }
    if (option && option?.floorPlan && option?.floorPlan?.includes('us-east-1')) {
      return [
        option?.floorPlan.replace(
          process.env.REACT_APP_PDF_HERO_IMAGE_URL.trim(),
          process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
        ),
      ];
    }
  };

  const createMarkup = (data) => {
    return { __html: data };
  };

  const imageList = imageUrlProcessing(option);

  const floorPlanImg = setFloorPlanImage(option);

  const galleryModeCB = useCallback((cb) => {
    setGalleryMode(cb);
  }, []);

  return (
    <>
      {IsSpinner && <Spinner />}
      <AllOptionsMainWrapper>
        <>
          {galleryMode ? (
            <MTGallaryModeComponent
              galleryMode={galleryMode}
              isPhotoState={isPhotoState}
              imageList={imageList}
              floorPlanImg={floorPlanImg}
              galleryModeCB={galleryModeCB}
              setPhotoIndexCB={setPhotoIndexCB}
              toggleCarouselStateCB={toggleCarouselStateCB}
            />
          ) : (
            <>
              {imageList?.length > 0 && (
                <MTImageCarouselComponent
                  imageList={imageList}
                  galleryMode={galleryMode}
                  floorPlanImg={floorPlanImg}
                  isPhotoState={isPhotoState}
                  carouselState={carouselState}
                  setPhotoIndex={setPhotoIndex}
                  setPhotoIndexCB={setPhotoIndexCB}
                  galleryModeCB={galleryModeCB}
                  toggleCarouselStateCB={toggleCarouselStateCB}
                />
              )}
              <OptionWrapper>
                <OptionContentWrapper>
                  <OptionContentName>{option?.optionName}</OptionContentName>
                  <OptionDetailsWrapper>
                    <ODLeft>Tour Details</ODLeft>
                    <ODRight>
                      {option?.tourScheduledDate && (
                        <ODRightWrapper>
                          {!option?.tourCompleted && (
                            <>
                              <TourIconStatusWrapper>
                                <EventOutlinedIcon className="tour-icon-mui" alt="Tour Schedule" />
                                <span>Tour Scheduled</span>
                              </TourIconStatusWrapper>
                              <span>
                                {formatDatefromTimeStamp(option.tourScheduledDate, 'MMM DD, YYYY')}{' '}
                                - {option.tourScheduledSlot}
                              </span>
                            </>
                          )}
                          {option?.tourCompleted && (
                            <>
                              <TourIconStatusWrapper>
                                <CheckCircleIcon className="tour-icon-mui" alt="Tour Completed" />
                                <span>Tour Completed</span>
                              </TourIconStatusWrapper>
                              <span>
                                {formatDatefromTimeStamp(option.tourScheduledDate, 'MMM DD, YYYY')}{' '}
                                - {option.tourScheduledSlot}
                              </span>
                            </>
                          )}
                          <>
                            {option?.contactName && (
                              <span>
                                Provider Contact Name: {option.contactName} <br />
                              </span>
                            )}
                            {option?.contactNumber && (
                              <span>Provider Contact Number: {option.contactNumber}</span>
                            )}
                          </>
                        </ODRightWrapper>
                      )}
                      {!option?.tourScheduledDate &&
                        option?.tourRequestedDate &&
                        !option?.tourCompleted &&
                        option?.tourRequestedDate.length > 0 && (
                          <ODRightWrapper>
                            <TourIconStatusWrapper>
                              <CorporateFareOutlinedIcon
                                className="tour-icon-mui"
                                alt="tour request"
                              />
                              <span>Tour Requested</span>
                            </TourIconStatusWrapper>
                            <>
                              {option?.sortedRequestedDates?.map((requestedDate, index) => (
                                <span key={`${requestedDate}-${index}`}>{requestedDate}</span>
                              ))}
                            </>{' '}
                          </ODRightWrapper>
                        )}
                    </ODRight>
                  </OptionDetailsWrapper>
                  {hasVisibleContent(createMarkup(option?.arrivalDetails)?.__html) && (
                    <OptionDetailsWrapper>
                      <ODLeft>Arrival Details</ODLeft>
                      <ODRight
                        dangerouslySetInnerHTML={createMarkup(option?.arrivalDetails)}
                        className="hidden-if-empty"
                      />
                    </OptionDetailsWrapper>
                  )}
                </OptionContentWrapper>
              </OptionWrapper>
            </>
          )}
        </>
      </AllOptionsMainWrapper>
      <MTClientRequirementCircleComponent surveyData={surveyData} currentDeal={currentDeal} />
    </>
  );
}

const AllOptionsMainWrapper = styled.div`
  background-color: #fff;
  padding: 15px 15px 60px;
  display: grid;
  position: relative;
  width: 100vw;
  margin: 0 auto;

  -webkit-overflow-scrolling: touch;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) and ${constNames.DEVICE_MEDIA
      .MOBILE_MAX} {
    padding: 15px;
    width: 100vw;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    width: calc(100vw - 90px);
  }
`;

const OptionWrapper = styled.div`
  background-color: #fff;
  padding: 12px;
  margin: 0 0 20px;
  border-radius: 8px;
  gap: 12px;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 auto;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) and ${constNames.DEVICE_MEDIA
      .MOBILE_MAX} {
    padding: 0;
    width: 340px;
    margin-bottom: 15px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} {
    width: 640px;
  }

  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    order: 3;
  }
`;

const OptionImageWrapper = styled.div`
  position: relative;
  display: flex;
  algin-items: center;
  justify-content: center;

  & img {
    width: 100%;
    height: 100%;
    min-height: 250px;
    object-fit: cover;
    border-radius: 8px;
    border: solid 1px #d8d8d8;
  }
`;

const OptionContentWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 12px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    gap: 30px;
  }
`;

const OptionDetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0;
  gap: 10px;
`;

const ODLeft = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.14px;
  color: #212121;
  margin: 10px 0 0;
`;

const ODRight = styled.div`
  color: rgba(33, 33, 33, 0.6);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  & span,
  & p {
    color: rgba(33, 33, 33, 0.6) !important;
  }
`;

const ODRightWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
`;

const TourIconStatusWrapper = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
  margin: 0;
  align-items: center;
  .tour-icon-mui {
    color: rgb(0, 63, 45);
  }
`;

const OptionContentName = styled.div`
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.3px;
  width: 100%;

  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION.POTRAIT} {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
`;

const ViewAllDetails = styled.div`
  color: #003f2d;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  justify-content: center;
`;

export default MTTourPageComponent;
